// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `toggle-map-style {
  border-radius: var(--border-radius);
  isolation: isolate;
}
toggle-map-style .toggle-map-style {
  background-color: var(--motes-white);
  width: 100px;
  height: 100px;
  border: 2px solid var(--motes-white);
  border-radius: inherit;
  box-shadow: var(--shadow-elevation-low);
  transition: 0.3s;
  position: relative;
}
toggle-map-style img {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}
toggle-map-style .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(to top, hsla(0, 0%, 0%, 0.3) 1rem, transparent 50%);
}
toggle-map-style .toggle-map-style button {
  position: absolute;
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: 1rem;
  padding: 0.5rem;
  cursor: pointer;
  font-family: var(--text-font);
  color: var(--motes-white);
}

toggle-map-style:hover {
  box-shadow: var(--shadow-elevation-medium);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/toggle-map-style/toggle-map-style.component.scss"],"names":[],"mappings":"AAAA;EACI,mCAAA;EACA,kBAAA;AACJ;AACI;EACI,oCAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,sBAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;AACR;AAEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAAR;AAGI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,+EAAA;AADR;AAII;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;AAFR;;AAMA;EACI,0CAAA;AAHJ","sourcesContent":["toggle-map-style {\n    border-radius: var(--border-radius);\n    isolation: isolate;\n\n    .toggle-map-style {\n        background-color: var(--motes-white);\n        width: 100px;\n        height: 100px;\n        border: 2px solid var(--motes-white);\n        border-radius: inherit;\n        box-shadow: var(--shadow-elevation-low);\n        transition: 0.3s;\n        position: relative;\n    }\n\n    img {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        border-radius: inherit;\n    }\n\n    .overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: inherit;\n        background: linear-gradient(to top, hsl(0deg, 0%, 0%, 0.3) 1rem, transparent 50%);\n    }\n\n    .toggle-map-style button {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        border: none;\n        background: transparent;\n        display: flex;\n        justify-content: center;\n        align-items: flex-end;\n        font-size: 1rem;\n        padding: 0.5rem;\n        cursor: pointer;\n        font-family: var(--text-font);\n        color: var(--motes-white);\n    }\n}\n\ntoggle-map-style:hover {\n    box-shadow: var(--shadow-elevation-medium);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
